import httpClient from '../../shared/services/httpClient';

export const SearchAllCity = async () => {
  return await httpClient.get('/city/all', { skipAuth: true });
};
